module.exports = __webpack_public_path__ + "img/icon-beneficiary.0702fe76.svg";